import React from "react";

export const HealthCoach = () => (
    <section className="panel" data-testid="health-coach">
        <div className="px-6 sm:px-8 py-5 border-b hairline">
            <p className="mono-label">Secondary route</p>
            <h2
                className="font-serif mt-1"
                style={{ fontSize: 26, letterSpacing: "-0.01em" }}
            >
                Certified health-coach follow-up
            </h2>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3">
            <div className="px-6 sm:px-8 py-5 lg:border-r hairline">
                <p className="mono-label">Scope of support</p>
                <ul className="mt-3 space-y-2" style={{ fontSize: 14 }}>
                    <li>· Adherence reminders</li>
                    <li>· Lifestyle support</li>
                    <li>· Appointment navigation</li>
                    <li>· Community check-ins</li>
                    <li>· Signposting</li>
                </ul>
            </div>
            <div className="px-6 sm:px-8 py-5 lg:border-r hairline">
                <p className="mono-label">Custody</p>
                <p
                    className="mt-3 font-serif"
                    style={{ fontSize: 15.5, lineHeight: 1.55 }}
                >
                    Community support receives only the task and bounded context
                    required to help.
                </p>
            </div>
            <div className="px-6 sm:px-8 py-5">
                <p className="mono-label">Authority</p>
                <p
                    className="mt-3 font-serif"
                    style={{ fontSize: 15.5, lineHeight: 1.55 }}
                >
                    Clinical decisions remain with authorised clinicians. Coaches
                    do not receive raw clinical records.
                </p>
            </div>
        </div>
    </section>
);

export default HealthCoach;
